export type FightSurface = 'selection' | 'fight'
export type FightFlowKind = 'roster-sync' | 'arena-ingress' | 'resume' | 'rematch' | 'next-rival'

export type FightFlowMeta = {
  surface: FightSurface
  eyebrow: string
  title: string
  detail: string
  minVisibleMs: number
  maxWaitMs: number
  accent: string
  secondary: string
  cinematicLabel: string
  quantumIntensity: number
}

export const FIGHT_FLOW_META: Record<FightFlowKind, FightFlowMeta> = {
  'roster-sync': {
    surface: 'selection',
    eyebrow: 'ASCENDANT ARCHIVE',
    title: 'CALLING THE ASCENDANTS',
    detail: 'Bringing every fighter and arena path into focus.',
    minVisibleMs: 420,
    maxWaitMs: 1400,
    accent: '#69ddf7',
    secondary: '#a87cff',
    cinematicLabel: 'ROSTER AWAKENING',
    quantumIntensity: .18,
  },
  'arena-ingress': {
    surface: 'fight',
    eyebrow: 'RIFT TRANSIT · LIVE COMBAT',
    title: 'ENTERING THE ARENA',
    detail: 'The rift opens as both Ascendants cross into the battleground.',
    minVisibleMs: 760,
    maxWaitMs: 2200,
    accent: '#70e8ff',
    secondary: '#ff7a9e',
    cinematicLabel: 'ARENA INGRESS',
    quantumIntensity: .74,
  },
  resume: {
    surface: 'fight',
    eyebrow: 'COMBAT OS // RESUME',
    title: 'RESTORING LIVE CONTROL',
    detail: 'Revalidating the frozen frame before input returns to the fighters.',
    minVisibleMs: 520,
    maxWaitMs: 1500,
    accent: '#88efff',
    secondary: '#8effcb',
    cinematicLabel: 'CONTROL RESTORATION',
    quantumIntensity: .28,
  },
  rematch: {
    surface: 'fight',
    eyebrow: 'MATCH CORE // RECALIBRATION',
    title: 'REARMING THE ARENA',
    detail: 'Resetting round state while preserving the selected fighters and battleground.',
    minVisibleMs: 640,
    maxWaitMs: 1800,
    accent: '#ffd27d',
    secondary: '#ff789a',
    cinematicLabel: 'TIMELINE RECALIBRATION',
    quantumIntensity: .52,
  },
  'next-rival': {
    surface: 'fight',
    eyebrow: 'RIFT LADDER // ASCENSION',
    title: 'SUMMONING NEXT RIVAL',
    detail: 'Rebinding the opponent profile, arena state and presentation shaders.',
    minVisibleMs: 720,
    maxWaitMs: 2100,
    accent: '#c08cff',
    secondary: '#69e7ff',
    cinematicLabel: 'RIFT ASCENSION',
    quantumIntensity: .68,
  },
}

export function fightFlowMeta(kind: FightFlowKind) {
  return FIGHT_FLOW_META[kind]
}